export enum ActionTypeEnum {
  None = 0,
  WorkflowTransitions = 1,
  DraftTransition = 2, //not visible on activity log
  ReviseTransition = 3,
  UpdateDocument = 4,
  Comment = 5,
  Approvals = 6, //not visible on activity log
  ChangeDocumentNumber = 7,
  AssociateVirtualDrawing = 8,
  SaveInstanceFromTemplate = 9, //not visible on activity log
  PreferredFieldValue = 10, //not visible on activity log
  RollbackTransition = 11,
  SaveInstanceFromCorrespondence = 12,
  SaveNotificationReplayFromCorrespondence = 13,
  Assignment = 14,
  Email = 15,
  CreateRelatedDocument = 16,
}

export const TranslatedActionTypes: ActionTypeEnum[] = [
  ActionTypeEnum.Comment,
  ActionTypeEnum.SaveInstanceFromCorrespondence,
  ActionTypeEnum.Assignment,
  ActionTypeEnum.SaveNotificationReplayFromCorrespondence,
  ActionTypeEnum.UpdateDocument,
  ActionTypeEnum.Email,
  ActionTypeEnum.RollbackTransition,
] as const;

export const ActivitiesWithState: ActionTypeEnum[] = [ActionTypeEnum.WorkflowTransitions, ActionTypeEnum.Assignment];
